export const AMAZON_S3_URL = 'https://s3.amazonaws.com/diocesan-eva/';
